import { useQuery } from '@tanstack/react-query';
import { api } from './api-client';
import { dateRangeToFrom } from './useInboxFolder';
import type { InboxFiltersState, InboxFolderCounts, InboxUnreadCountDto } from './types';

export function useInboxUnreadCount() {
  return useQuery({
    queryKey: ['inbox', 'unread-count'],
    queryFn: () => api.get<InboxUnreadCountDto>('/v1/inbox/unread-count'),
    refetchInterval: 30_000,
  });
}

// The rail counts honor the SAME filters as the list: q (trimmed) and a `from` derived from the
// date range via the shared dateRangeToFrom helper, so folder totals + category chips + canMarkAll
// never drift from the filtered list.
export function useInboxFolderCounts(filters: InboxFiltersState) {
  // Trim q before it enters the query key (and the request), matching the list hook exactly.
  const q = filters.q.trim();
  return useQuery({
    queryKey: ['inbox', 'folder-counts', q, filters.dateRange],
    queryFn: () => {
      const params = new URLSearchParams();
      const from = dateRangeToFrom(filters.dateRange);
      if (from) params.set('from', from);
      if (q) params.set('q', q);
      const suffix = params.toString();
      return api.get<InboxFolderCounts>(`/v1/inbox/folders${suffix ? `?${suffix}` : ''}`);
    },
    refetchInterval: 30_000,
  });
}
